import { render, staticRenderFns } from "./MatchHeader.vue?vue&type=template&id=cc20d6f8&scoped=true&"
import script from "./MatchHeader.vue?vue&type=script&lang=js&"
export * from "./MatchHeader.vue?vue&type=script&lang=js&"
import style0 from "./MatchHeader.vue?vue&type=style&index=0&id=cc20d6f8&scoped=true&lang=css&"
import style1 from "./MatchHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc20d6f8",
  null
  
)

export default component.exports